import { GuidedSearchHelper } from '@organisms/guided-search/guidedSearchHelper';
import { Requests } from '@tools/requests';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { flashBagError } from '../flashbag';
import { URL_GUIDED_SEARCH_CREATE } from '../routes/routes';

const getSteps = () => {
  const steps = [];
  for (let i = 1; i <= 6; i++) {
    steps.push({
      title: `guided_search.step.${i}.title`,
    });
  }
  return steps;
};

const getDefaultState = () => ({
  actualStep: 0,
  displayStepperModal: false,
  steps: getSteps(),
  stepValues: {
    installationMonth: null,
    location: null,
    capacity: null,
    duration: null,
    budget: {
      price: null,
      isUnknown: false,
    },
    organization: null,
    user: {
      fullName: '',
      email: '',
      phoneNumber: '',
      phoneNumberIsValid: false,
    },
  },
  userData: null,
  offersCount: 0,
  customSearchUrl: '',
});

export const useFormGuidedSearchStore = defineStore('formGuidedSearch', () => {
  const actualStep = ref(0);
  const displayStepperModal = ref(false);
  const steps = ref(getSteps());
  const stepValues = ref(getDefaultState().stepValues);
  const userData = ref(null);
  const offersCount = ref(0);
  const customSearchUrl = ref('');

  const changeActualStep = (step) => {
    actualStep.value = step;
  };

  const setUserData = () => {
    userData.value = window.initialAppState?.user_data || null;
  };

  const setStepValue = ({ step, stepDetails, value }) => {
    if (!stepDetails) {
      stepValues.value[step] = value;
      return;
    }
    stepValues.value[step][stepDetails] = value;
  };

  const sendData = async () => {
    try {
      const requestData = GuidedSearchHelper.formatDataStore(stepValues.value);

      const response = await Requests.post(
        URL_GUIDED_SEARCH_CREATE,
        requestData,
      );

      if (response.status !== 200) {
        throw new Error();
      }

      offersCount.value = response.data.offers_count;
      customSearchUrl.value = response.data.search_url;

      window.dataLayer.push({
        event: 'screenChange',
        step: 'completion',
        funnel: 'support-contact-form',
        ...response.data.data,
      });

      return true;
    } catch (error) {
      flashBagError();
      return false;
    }
  };

  return {
    actualStep,
    displayStepperModal,
    steps,
    stepValues,
    userData,
    offersCount,
    customSearchUrl,
    changeActualStep,
    setUserData,
    setStepValue,
    sendData,
  };
});
